import { render, staticRenderFns } from "./WebhookInputs.vue?vue&type=template&id=41a8de8e&"
import script from "./WebhookInputs.vue?vue&type=script&lang=ts&"
export * from "./WebhookInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports